import {
  AssetSnapshot,
  OperationModeSnapshot,
  ProducingOperationModeSnapshot
} from '@hconnect/common/types'

export const guardProducingMode = (
  operationMode: OperationModeSnapshot
): operationMode is ProducingOperationModeSnapshot =>
  !!operationMode.recipeId && !!operationMode.throughput

export const getOperationModeIdToAssetIdMap = (assets: AssetSnapshot[]): Record<string, number> =>
  assets.reduce<Record<string, number>>((operationModeToAssetsMap, item) => {
    const operationModesToAsset = item.operationModes.reduce<Record<string, number>>(
      (acc, operationMode) => ({...acc, [operationMode.id]: item.id}),
      {}
    )
    return {
      ...operationModeToAssetsMap,
      ...operationModesToAsset
    }
  }, {})
